const metodoDeEnvio = {
    TIENDA: 'tienda',
    DOMICILIO: 'domicilio'
}

export default metodoDeEnvio;